// extracted by mini-css-extract-plugin
export default {"root":"notFound_root__zPyKV","title":"notFound_title__WRaPO","description":"notFound_description__ds3pR"};